/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {LineItemBulkActionModalComponent} from './line-item-bulk-action-modal.component';

@Injectable({providedIn: 'root'})
export class LineItemBulkActionService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  createBulkAction(list: any): () => void {
    return () => {
      this.angularModalService.show(LineItemBulkActionModalComponent, {
        class: 'modal-lg',
        initialState: {list}
      });
    };
  }
}
